import { IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { cls } from "../hatim/soft/SoftKit";
import { TYPE_LABEL, correctAnswerLabel, issueText, questionIssue } from "./questionRules";

/**
 * Soruların ince çizgili satırları (mobil QuestionRows): sıra, metin, tip,
 * şıklar ve doğru cevap. onEdit verilirse satıra basınca düzenlenir, onRemove
 * verilirse sağda kaldırma düğmesi çıkar; showIssues eksik soruyu işaretler.
 */
export default function QuestionRows({ questions, showAnswers = true, onEdit, onRemove, showIssues, disabled }) {
  const { t } = useScriptMode();
  return (
    <ul className="border-t border-terakkiBorder dark:border-white/[0.14]">
      {(questions || []).map((q, index) => {
        const issue = showIssues ? questionIssue(q) : null;
        const answer = showAnswers && q.type !== "coktan" ? correctAnswerLabel(q, t) : "";
        const body = (
          <div className="flex items-start gap-2 min-w-0 flex-1">
            <span className={`text-xs pt-0.5 w-5 shrink-0 ${cls.muted}`}>{`${index + 1}.`}</span>
            <div className="min-w-0 flex-1 flex flex-col gap-0.5">
              <span className={`text-sm break-words ${cls.title}`}>{q.text || "..."}</span>
              <span className={`text-xs ${cls.muted}`}>
                {answer ? `${t(TYPE_LABEL[q.type])} · ${t("assess_correct_answer")}: ${answer}` : t(TYPE_LABEL[q.type])}
              </span>
              {q.type === "coktan"
                ? (q.options || []).map((option, i) => {
                    const correct = showAnswers && q.correctIndex === i;
                    return (
                      <span
                        key={i}
                        className={`flex items-center gap-1.5 text-xs ${
                          correct ? "text-[#2E9E6A] dark:text-[#7BE3A8]" : cls.muted
                        }`}
                      >
                        {correct ? (
                          <CheckCircleIcon sx={{ fontSize: 13 }} />
                        ) : (
                          <span className="w-[13px] text-center" aria-hidden>
                            ·
                          </span>
                        )}
                        <span className="break-words">{option || "..."}</span>
                      </span>
                    );
                  })
                : null}
              {issue ? <span className={`text-xs ${cls.danger}`}>{t(issueText(issue))}</span> : null}
            </div>
          </div>
        );
        return (
          <li key={q.qid} className={`flex items-start gap-1 ${cls.row}`}>
            {onEdit ? (
              <button
                type="button"
                onClick={() => onEdit(index)}
                disabled={disabled}
                className={`flex-1 min-w-0 text-left px-1 py-2.5 ${cls.rowHover}`}
              >
                {body}
              </button>
            ) : (
              <div className="flex-1 min-w-0 px-1 py-2.5">{body}</div>
            )}
            {onRemove ? (
              <IconButton
                size="small"
                onClick={() => onRemove(index)}
                disabled={disabled}
                aria-label={t("mzq_remove_question")}
                sx={{ mt: 1 }}
              >
                <CloseIcon fontSize="small" className={cls.muted} />
              </IconButton>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
